/* eslint-disable no-useless-escape */
/* eslint-disable react/button-has-type */
/* eslint-disable max-len */
import { useState } from 'react';
import { motion } from 'framer-motion';
import {
  FaCalendarAlt, FaUserAlt, FaChevronRight, FaSearch
} from 'react-icons/fa';

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } }
};

const staggerVariant = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const itemVariant = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.4, ease: 'easeOut' } }
};

// Styles
const colors = {
  primary: '#3a86ff',
  secondary: '#ff006e',
  accent: '#8338ec',
  success: '#06d6a0',
  warning: '#ffbe0b',
  dark: '#1e2a3a',
  light: '#f8f9fa',
  darkGradient: 'linear-gradient(135deg, #0b1120 0%, #1e293b 100%)',
  glassEffect: 'rgba(255, 255, 255, 0.03)',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
};

const fontFamily = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

const sectionStyle = {
  padding: '120px 24px',
  backgroundColor: colors.light,
  fontFamily,
  position: 'relative',
  overflow: 'hidden',
};

function News() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Articles d'actualité
  const newsArticles = [
    {
      id: 1,
      title: 'Lancement de la version 3.0 de Drivesoft',
      excerpt: 'Nous sommes fiers d\'annoncer le lancement de la version 3.0 de notre solution, avec des fonctionnalités concrètes pour transformer la gestion du transport sanitaire.',
      content: 'La version 3.0 de Drivesoft est désormais disponible pour tous nos clients. Cette mise à jour majeure apporte des améliorations significatives demandées par nos utilisateurs :\n\n1. Nouveau tableau de bord unifié - Une interface centralisée regroupant toutes les informations essentielles pour les gestionnaires et les régulateurs.\n\n2. Optimisation des trajets en temps réel - Recalcul automatique des itinéraires en fonction du trafic et des événements imprévus.\n\n3. Application mobile repensée - Plus rapide, plus intuitive et fonctionnant même en zones de faible couverture réseau.\n\n4. Gestion simplifiée de la facturation - Automatisation des processus de facturation avec vérification instantanée des droits du patient.\n\nTous nos clients bénéficieront d\'une mise à jour gratuite vers cette nouvelle version, avec un déploiement progressif qui débutera le mois prochain. Notre équipe support organisera des sessions de formation pour vous accompagner dans cette transition.\n\nNous remercions tous les clients qui ont participé à notre programme bêta et dont les retours précieux ont contribué à façonner cette nouvelle version.',
      author: 'Équipe Drivesoft',
      date: '15 mars 2025',
      category: 'nouveautes',
      image: 'https://images.unsplash.com/photo-1581090700227-1e37b190418e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 2,
      title: 'Drivesoft sera présent au Salon International de la Santé 2025',
      excerpt: 'Retrouvez-nous au Salon International de la Santé 2025 à Paris du 15 au 18 septembre pour découvrir nos innovations et participer à nos ateliers exclusifs.',
      content: 'Nous sommes ravis de vous annoncer notre participation au Salon International de la Santé 2025, l\'événement de référence pour les professionnels du secteur qui se tiendra à Paris Expo Porte de Versailles du 15 au 18 septembre 2025.\n\nCette année, notre stand (Hall 7, Stand C45) mettra en avant notre écosystème complet de solutions pour le transport sanitaire avec des démonstrations en direct de notre plateforme Drivesoft 3.0. Nous présenterons également en avant-première notre nouvelle application mobile destinée aux patients, permettant un suivi en temps réel de leur prise en charge.\n\nNotre équipe organisera plusieurs ateliers et conférences tout au long de l\'événement:\n- 15/09 à 14h: \"L\'IA au service du transport sanitaire\" - Salle Pasteur\n- 16/09 à 11h: \"Optimisation des ressources en situation d\'urgence\" - Espace Innovation\n- 17/09 à 15h30: Table ronde \"Transport sanitaire de demain\" avec plusieurs acteurs clés du secteur\n\nPour réserver une démonstration personnalisée ou un rendez-vous avec notre équipe pendant le salon, n\'hésitez pas à nous contacter via notre formulaire dédié sur notre site web.',
      author: 'Service Communication',
      date: '22 juillet 2025',
      category: 'evenements',
      image: 'https://images.unsplash.com/photo-1540304453527-62f979142a17?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 3,
      title: 'Nouvelles réglementations 2025 pour le transport sanitaire : ce qui change',
      excerpt: 'Analyse détaillée des changements réglementaires majeurs prenant effet en 2025 et comment Drivesoft vous aide à rester conforme.',
      content: 'Le 1er janvier 2025 marque l\'entrée en vigueur de nouvelles dispositions réglementaires importantes qui impactent directement le secteur du transport sanitaire en France. Ces modifications, issues du décret n°2024-1278 du 15 novembre 2024, introduisent plusieurs exigences auxquelles les entreprises doivent se conformer rapidement.\n\nParmi les changements les plus significatifs:\n\n1. Traçabilité renforcée - L\'obligation de conserver un historique numérique complet de chaque transport pendant 5 ans (contre 3 précédemment), incluant des informations plus détaillées sur le parcours et l\'état du patient.\n\n2. Normes environnementales - L\'accélération du calendrier de transition vers des véhicules à faibles émissions, avec 40% de la flotte devant être conforme d\'ici fin 2026.\n\n3. Formation continue - Un nouveau minimum de 20 heures de formation annuelle pour tous les personnels, avec une certification numérique obligatoire.\n\nDrivesoft a anticipé ces évolutions et notre version 3.0 intègre déjà toutes les fonctionnalités nécessaires pour vous permettre de rester en conformité sans effort supplémentaire. Notre module de conformité réglementaire a été spécialement mis à jour et peut générer automatiquement tous les rapports exigés par les autorités.\n\nNous organiserons un webinaire le 25 janvier 2025 pour détailler ces changements et montrer comment notre solution vous accompagne face à ces nouvelles exigences.',
      author: 'Équipe Drivesoft',
      date: '5 janvier 2025',
      category: 'reglementation',
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 4,
      title: 'Étude de cas : Comment Jussieu Secours PARIS a réduit ses coûts de 30% avec Drivesoft',
      excerpt: 'Découvrez comment une entreprise de transport sanitaire de taille moyenne a transformé ses opérations et optimisé sa rentabilité grâce à notre solution.',
      content: 'Jussieu secours PARIS, entreprise familiale basée à Paris et opérant 22 véhicules, a rejoint la famille Drivesoft en 2023 alors qu\'elle faisait face à des défis majeurs : augmentation des coûts de carburant, difficultés de planification et charge administrative croissante.\n\nAprès 18 mois d\'utilisation de notre solution, les résultats sont remarquables:\n\n- Réduction de 30% des coûts opérationnels globaux\n- Diminution de 22% de la consommation de carburant grâce à l\'optimisation intelligente des trajets\n- Gain de 15 heures par semaine sur les tâches administratives\n- Amélioration de 40% du taux de satisfaction des patients\n- Réduction de 95% des erreurs de facturation\n\n"Drivesoft a complètement transformé notre façon de travailler", témoigne Aymeric POURRE, directeur de Jussieu Secours PARIS. "La transition a été simple et l\'équipe support a été présente à chaque étape. Nos chauffeurs apprécient particulièrement l\'application mobile qui leur facilite grandement le quotidien, et notre service administratif a pu se recentrer sur des tâches à plus forte valeur ajoutée."\n\nL\'entreprise a notamment mis en place une utilisation innovante de notre module de planification prédictive, en l\'intégrant à leur stratégie de recrutement et de gestion des ressources humaines, ce qui leur a permis d\'optimiser leurs effectifs tout en améliorant les conditions de travail.\n\nJussieu Secours PARIS prévoit maintenant de développer son activité en ouvrant une nouvelle antenne, projet facilité par la scalabilité de notre solution.',
      author: 'Équipe Études de Cas',
      date: '28 novembre 2024',
      category: 'temoignages',
      image: 'https://images.unsplash.com/photo-1516841273335-e39b37888115?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 9,
      title: 'La version 2.0 de Drivesoft est disponible',
      excerpt: 'Une refonte majeure de notre interface et de nouvelles fonctionnalités pour améliorer l\'expérience utilisateur et l\'efficacité opérationnelle.',
      content: 'Après plus d\'un an de développement et une phase bêta intensive impliquant une centaine d\'utilisateurs pilotes, nous sommes heureux d\'annoncer la disponibilité générale de Drivesoft 2.0, représentant la plus importante mise à jour de notre solution depuis son lancement.\n\nCette nouvelle version offre:\n\n1. Une interface utilisateur complètement repensée, plus intuitive et adaptative, s\'ajustant automatiquement aux différents rôles des utilisateurs\n\n2. Un moteur d\'optimisation de planification de nouvelle génération, utilisant des algorithmes avancés de machine learning pour améliorer la prédiction des temps de trajet et la gestion des imprévus\n\n3. Des tableaux de bord analytiques personnalisables offrant une vision complète de l\'activité et des indicateurs de performance clés\n\n5. Une nouvelle application mobile pour les équipiers, avec navigation intégrée et signature électronique\n\n6. Des intégrations améliorées avec les systèmes tiers, notamment les logiciels de comptabilité et les plateformes d\'assurance maladie\n\nLes fonctionnalités phares comme la géolocalisation en temps réel, la facturation automatisée et la gestion des documents ont également été enrichies et optimisées.\n\n"Drivesoft 2.0 marque un tournant dans notre vision du transport sanitaire digitalisé", explique Katarina Breux, Directice marketing. "Nous avons repensé chaque aspect de la solution pour répondre aux défis quotidiens rencontrés par nos utilisateurs, tout en préparant le terrain pour les innovations futures."\n\nTous nos clients actuels bénéficieront d\'une migration automatique vers cette nouvelle version dans les prochaines semaines, accompagnée de sessions de formation dédiées pour exploiter pleinement ces nouvelles capacités.',
      author: 'Équipe Produit',
      date: '15 juin 2023',
      category: 'nouveautes',
      image: 'https://images.unsplash.com/photo-1596741964346-791466b552b6?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    },
    {
      id: 11,
      title: 'Drivesoft lance sa solution de gestion pour le transport sanitaire',
      excerpt: 'Une plateforme innovante conçue pour optimiser les opérations et réduire les coûts des entreprises de transport sanitaire.',
      content: 'C\'est avec enthousiasme que nous annonçons officiellement le lancement de Drivesoft, notre solution complète de gestion dédiée aux entreprises de transport sanitaire, après deux années de développement intensif et six mois de tests approfondis auprès d\'un panel d\'entreprises pilotes.\n\nDrivesoft répond aux défis majeurs rencontrés par les professionnels du secteur en proposant une plateforme tout-en-un qui intègre:\n\n- La planification et la gestion des missions avec optimisation des tournées\n- La géolocalisation des véhicules en temps réel\n- La gestion administrative et la facturation automatisée\n- Le suivi des patients et la coordination avec les établissements de santé\n- Le reporting et l\'analyse des performances\n\nNotre solution se distingue par son interface intuitive, son adaptabilité aux différentes tailles d\'entreprises (de l\'artisan à la grande structure multi-sites) et sa conformité stricte avec les réglementations en vigueur dans le secteur du transport sanitaire.\n\n"Nous avons conçu Drivesoft en collaboration étroite avec des professionnels du transport sanitaire pour créer un outil qui répond précisément à leurs besoins quotidiens", explique Florent Breux, fondateur et CEO. "Notre ambition est de permettre aux entreprises de se concentrer sur leur cœur de métier - la prise en charge des patients - en les libérant des contraintes administratives et logistiques."\n\nLes premiers utilisateurs témoignent déjà de bénéfices significatifs: une réduction moyenne de 23% du temps consacré aux tâches administratives, une optimisation de 15% des trajets et une diminution notable des erreurs de facturation.\n\nDrivesoft est disponible dès aujourd\'hui sous forme d\'abonnement mensuel, avec différentes formules adaptées aux besoins spécifiques de chaque entreprise. Nous proposons également un accompagnement personnalisé pour la mise en place et la formation des équipes.\n\nPour découvrir notre solution, nous vous invitons à participer à l\'un de nos webinaires de démonstration hebdomadaires ou à demander une démonstration personnalisée via notre site web.',
      author: 'Équipe Drivesoft',
      date: '20 avril 2021',
      category: 'lancement',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
    }
  ];

  // Filtrer les articles par recherche
  const filteredArticles = newsArticles.filter((article) => {
    // Si searchTerm est vide, afficher tous les articles
    if (!searchTerm.trim()) {
      return true;
    }
    const matchesSearch = article.title.toLowerCase().includes(searchTerm.toLowerCase())
                          || article.excerpt.toLowerCase().includes(searchTerm.toLowerCase())
                          || article.content.toLowerCase().includes(searchTerm.toLowerCase());

    return matchesSearch;
  });

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const openArticle = (article) => {
    setSelectedArticle(article);
    setShowModal(true);
    // Empêcher le défilement du body quand la modal est ouverte
    document.body.style.overflow = 'hidden';
  };

  const closeArticle = () => {
    setShowModal(false);
    setSelectedArticle(null);
    // Réactiver le défilement
    document.body.style.overflow = 'auto';
  };

  return (
    <div style={{ overflow: 'hidden' }}>
      {/* HERO SECTION */}
      <motion.section
        style={{
          ...sectionStyle,
          background: colors.darkGradient,
          color: colors.light,
          paddingTop: '150px',
          paddingBottom: '100px',
          textAlign: 'center',
          position: 'relative'
        }}
        initial="hidden"
        animate="visible"
        variants={fadeInUp}
      >
        {/* Éléments décoratifs */}
        <div style={{
          position: 'absolute',
          top: '0',
          left: '10%',
          width: '300px',
          height: '300px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(58, 134, 255, 0.3) 0%, transparent 70%)',
          filter: 'blur(80px)',
          zIndex: 0,
          opacity: 0.5
        }}
        />

        <div style={{
          position: 'absolute',
          bottom: '0',
          right: '10%',
          width: '250px',
          height: '250px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255, 0, 110, 0.3) 0%, transparent 70%)',
          filter: 'blur(60px)',
          zIndex: 0,
          opacity: 0.5
        }}
        />

        <div style={{
          position: 'relative', zIndex: 1, maxWidth: '900px', margin: '0 auto'
        }}
        >
          <motion.h1
            variants={itemVariant}
            style={{
              fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
              fontWeight: '800',
              marginBottom: '30px',
              background: 'linear-gradient(90deg, #ffffff 0%, #a2d6fc 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              letterSpacing: '-0.5px',
              lineHeight: '1.2',
            }}
          >
            Actualités
          </motion.h1>

          <motion.p
            variants={itemVariant}
            style={{
              fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
              fontWeight: '400',
              maxWidth: '700px',
              margin: '0 auto 50px',
              color: 'rgba(255, 255, 255, 0.85)',
              lineHeight: '1.6',
            }}
          >
            Restez informé des dernières nouvelles de Drivesoft et du secteur du transport sanitaire
          </motion.p>
        </div>
      </motion.section>

      {/* SECTION ARTICLES */}
      <motion.section
        style={{
          ...sectionStyle,
          background: 'linear-gradient(135deg, #f8f9fa 0%, #f1f5f9 100%)',
          paddingTop: '80px'
        }}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        variants={fadeInUp}
      >
        <div style={{
          position: 'relative', zIndex: 1, maxWidth: '1200px', margin: '0 auto'
        }}
        >
          {/* Barre de recherche et filtres */}
          <motion.div
            variants={itemVariant}
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '20px',
              marginBottom: '60px',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{
              position: 'relative',
              flex: '1 1 300px',
              maxWidth: '400px',
            }}
            >
              <FaSearch style={{
                position: 'absolute',
                left: '15px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#64748b',
                fontSize: '16px'
              }}
              />
              <input
                type="text"
                placeholder="Rechercher un article..."
                value={searchTerm}
                onChange={handleSearchChange}
                style={{
                  width: '100%',
                  padding: '15px 15px 15px 45px',
                  borderRadius: '10px',
                  border: 'none',
                  backgroundColor: 'white',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
                  fontSize: '1rem',
                  color: colors.dark,
                  fontFamily
                }}
              />
            </div>
          </motion.div>

          {/* Articles */}
          <motion.div
            variants={staggerVariant}
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
              gap: '30px',
              marginBottom: '60px'
            }}
          >
            {filteredArticles.length > 0 ? (
              filteredArticles.map((article) => (
                <motion.div
                  key={article.id}
                  variants={itemVariant}
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.06)',
                    border: '1px solid rgba(0, 0, 0, 0.03)',
                    transition: 'all 0.3s ease',
                  }}
                  whileHover={{
                    y: -10,
                    boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)'
                  }}
                >
                  <div style={{
                    height: '200px',
                    overflow: 'hidden',
                    position: 'relative'
                  }}
                  >
                    <img
                      src={article.image}
                      alt={article.title}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.5s ease'
                      }}
                    />
                  </div>

                  <div style={{ padding: '25px' }}>
                    <h3 style={{
                      fontSize: '1.3rem',
                      fontWeight: '700',
                      marginBottom: '15px',
                      color: colors.dark,
                      lineHeight: '1.4'
                    }}
                    >
                      {article.title}
                    </h3>

                    <p style={{
                      fontSize: '0.95rem',
                      color: '#64748b',
                      lineHeight: '1.7',
                      marginBottom: '20px'
                    }}
                    >
                      {article.excerpt}
                    </p>

                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginTop: '20px',
                      borderTop: '1px solid rgba(0, 0, 0, 0.05)',
                      paddingTop: '20px'
                    }}
                    >
                      <div>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '0.9rem',
                          color: '#64748b',
                          marginBottom: '8px'
                        }}
                        >
                          <FaUserAlt style={{ marginRight: '8px', fontSize: '0.8rem' }} />
                          {article.author}
                        </div>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          fontSize: '0.9rem',
                          color: '#64748b'
                        }}
                        >
                          <FaCalendarAlt style={{ marginRight: '8px', fontSize: '0.8rem' }} />
                          {article.date}
                        </div>
                      </div>

                      <motion.button
                        whileHover={{ x: 3 }}
                        onClick={() => openArticle(article)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          backgroundColor: 'transparent',
                          border: 'none',
                          color: colors.primary,
                          fontWeight: '600',
                          fontSize: '0.95rem',
                          cursor: 'pointer',
                          padding: '8px',
                          fontFamily
                        }}
                      >
                        Lire plus
                        <FaChevronRight style={{ marginLeft: '8px', fontSize: '0.8rem' }} />
                      </motion.button>
                    </div>
                  </div>
                </motion.div>
              ))
            ) : (
              <div style={{
                gridColumn: '1 / -1',
                textAlign: 'center',
                padding: '50px',
                backgroundColor: 'white',
                borderRadius: '16px',
                boxShadow: '0 10px 25px rgba(0, 0, 0, 0.06)',
              }}
              >
                <h3 style={{
                  fontSize: '1.3rem',
                  fontWeight: '600',
                  color: colors.dark,
                  marginBottom: '15px'
                }}
                >
                  Aucun article trouvé
                </h3>
                <p style={{ color: '#64748b' }}>
                  Essayez d'ajuster vos critères de recherche ou consultez toutes les actualités.
                </p>
              </div>
            )}
          </motion.div>
        </div>
      </motion.section>

      {/* Modal pour afficher l'article complet */}
      {showModal && selectedArticle && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 1000,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          overflow: 'auto',
          padding: '30px 20px',
        }}
        >
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            style={{
              backgroundColor: 'white',
              borderRadius: '16px',
              width: '100%',
              maxWidth: '900px',
              maxHeight: '90vh',
              overflow: 'auto',
              position: 'relative',
              boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
            }}
          >
            <div
              style={{
                position: 'sticky',
                top: 0,
                backgroundColor: 'white',
                padding: '20px',
                borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                zIndex: 10,
              }}
            >
              <button
                onClick={closeArticle}
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: colors.dark,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  transition: 'all 0.2s ease',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                ×
              </button>
            </div>

            <div style={{ position: 'relative', height: '300px', overflow: 'hidden' }}>
              <img
                src={selectedArticle.image}
                alt={selectedArticle.title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 100%)',
                padding: '80px 40px 40px',
                color: 'white',
              }}
              >
                <h1 style={{
                  fontSize: '2rem',
                  fontWeight: '700',
                  marginBottom: '10px',
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}
                >
                  {selectedArticle.title}
                </h1>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '0.9rem',
                  color: 'rgba(255, 255, 255, 0.8)',
                }}
                >
                  <FaUserAlt style={{ marginRight: '8px', fontSize: '0.8rem' }} />
                  {selectedArticle.author}
                  <span style={{ margin: '0 10px' }}>•</span>
                  <FaCalendarAlt style={{ marginRight: '8px', fontSize: '0.8rem' }} />
                  {selectedArticle.date}
                </div>
              </div>
            </div>

            <div style={{ padding: '40px' }}>
              <p style={{
                fontSize: '1.1rem',
                fontWeight: '500',
                color: colors.dark,
                marginBottom: '30px',
                lineHeight: '1.6',
              }}
              >
                {selectedArticle.excerpt}
              </p>

              <div style={{
                fontSize: '1rem',
                color: '#4a5568',
                lineHeight: '1.8',
                whiteSpace: 'pre-line',
              }}
              >
                {selectedArticle.content}
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
}

export default News;
